import CryptoJS from 'crypto-js'

export const CryptoPassword =
  "7b67ff8e6a67b866d898a128fe199da657d197107f2f2c4dfc6187cc61fabb4d";

export const encryptedText = (password, value) => {
  return CryptoJS.AES.encrypt(value, password).toString();
}

export const decryptedText = (password, encryptedValue) => {
  const bytes = CryptoJS.AES.decrypt(encryptedValue, password);
  return bytes.toString(CryptoJS.enc.Utf8);
}